import store from '@/store'
import { getToken } from '@/utils/user-info'
const { Message, MessageBox } = ELEMENT
const disableLog = false
// create an axios instance
const service = axios.create({
  baseURL: process.env.API_ROOT // api的base_url
  // timeout: 5000 // request timeout
})
// request interceptor
service.interceptors.request.use(config => {
  !disableLog && config.params && console.log(`${config.url} ${config.method} 请求params`, JSON.parse(JSON.stringify(config.params)))
  !disableLog && config.data && console.log(`${config.url} ${config.method} 请求body`, JSON.parse(JSON.stringify(config.data)))

  // Do something before request is sent
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    const config = response.config
    if (!res) {
      Message.error('网络异常，请稍后重新尝试')
      return Promise.reject(new Error('no data'))
    }
    !disableLog && console.log(`${config.url} ${config.method} 返回data：`, JSON.parse(JSON.stringify(res)))
    if (!res.code) {
      return res
    } else if (res.code === 401) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          window.location.reload()
        })
      })
    } else if (config.noErrorCheck) {
      return res
    } else if (config.ignoreErrorCode && config.ignoreErrorCode.indexOf(res.code) > -1) {
      return res
    } else if (res.code === store.getters.errorCode.SUCCESS) {
      return res
    } else {
      !config.noErrorShow && Message.error(store.getters.errorMsg[res.code] || '网络异常，请稍后重新尝试')
      return Promise.reject(res)
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message.error('网络异常，请稍后重新尝试')
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js